import Bundle, { PRODUCT_TYPES } from '@src/quince-site-common/src/domains/Product/BundleProduct'
import { ProductOptionDisplayType } from '@src/quince-site-common/src/domains/ProductOption'
import { ProductVariantOption } from '@src/quince-site-common/src/domains/ProductVariant'

export const getFilteredTagsForBundle = (product: Bundle) => {
  const selectedOption = getSelectedOptions(product)
  const filteredTags = product.tags
    .filter(tag => {
      if (!tag.options?.length) return true
      return tag.options.some((tagOption: ProductVariantOption) => tagOption.value === selectedOption?.[0]?.value)
    })
    .map(tag => ({ value: tag.value, tagType: tag.tagType, options: tag.options }))
    .filter((tag, index, self) => self.findIndex(t => t.value === tag.value) === index)
  return filteredTags
}

const getSelectedOptions = (product: Bundle) => {
  const cardOption = product.productOptions.find(option => option.name === 'Color')

  if (!cardOption) return []

  if (product.type === PRODUCT_TYPES.BUNDLE) {
    return cardOption?.values
      ?.filter(value => value.displayType === ProductOptionDisplayType.COLOR)
      ?.map(option => {
        return { ...option, name: cardOption.name }
      })
  }
  return []
}
